export default {
    orders: [],
    ordersLoading: false,
    wmdDeliveryStatusNames: null,
    productsList: [],
    commentsList: [],
    setInitialFilters: setInitialFilters,
    filters: setInitialFilters()
}

function setInitialFilters() {
    return {
        status_id: null,
        ordering: null,
        productName: null,
        productType_id: null,
        shopOrderNumber: null,
        createdAt__gte: null,
        createdAt__lte: null,
        plannedSendDate__gte: null,
        plannedSendDate__lte: null,
        isComplaint: null
    }
}